export default "__VITE_ASSET__335501f5__"